module.exports = __webpack_public_path__ + "6a2b7154c8384d20dbdf889e088d2e88.MP3";